import React from 'react';

import { ApiObject, Program, School } from 'app/types';
import Text from 'common/components/Text/Text';

import styles from 'features/explore/school/SchoolDetail.module.scss';
import { useMediaQuery } from 'react-responsive';
import { ContactPeople, StarContact, TriangleContact } from 'assets/explore';
import { entityIsProgram, entityIsSchool } from 'common/utils';

interface CompProps {
  entity: ApiObject<School> | ApiObject<Program> | undefined;
}

export const ContactBanner = ({ entity }: CompProps): React.ReactElement => {
  const isMobile = useMediaQuery({ maxWidth: 768 });
  return (
    <div className={styles.sectionContainer} style={!isMobile ? { marginTop: '32px' } : undefined}>
      <div className={styles.contactBannerContainer}>
        <img src={StarContact} className={styles.sunContact}></img>
        {isMobile && <img src={TriangleContact} className={styles.triangleContact}></img>}
        <img src={ContactPeople} className={styles.contactPeople}></img>
        <div className={styles.contactInformation}>
          <Text
            size={isMobile ? 16 : 20}
            weight={600}
            inlineStyle={
              isMobile
                ? {
                    textAlign: 'center',
                    color: '#19234F',
                  }
                : { color: '#19234F', maxWidth: 'inherit' }
            }
          >
            {entityIsProgram(entity?.data)
              ? `Contact ambassador in the ${entity?.data.school.name}!`
              : `Contact ambassador in the ${entity?.data.name}!`}
            {!isMobile && <img src={TriangleContact} className={styles.triangleContact}></img>}
          </Text>
          <button className={`btn btn-primary btn-lg ${styles.matchingButton}`}>Contact</button>
        </div>
      </div>
    </div>
  );
};
